export default __webpack_public_path__ + "static/media/ico-phone.1c34f9a5.png";